import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../services/api';

export const useUploadProfilePhoto = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post<{ photoUrl: string }>('/users/photo', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      return response.data.photoUrl;
    },
    onSuccess: () => {
      // Invalidate baseUser so photoUrl updates everywhere
      queryClient.invalidateQueries({ queryKey: ['baseUser'] });
    },
  });
};
